(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadRelatedProductsIntoSection = function() {
  var sections = document.querySelectorAll('.related-products[data-url]');
  sections.forEach(function(relatedProductsSection) {
    var intent = relatedProductsSection.dataset.intent || 'related';
    var request = new XMLHttpRequest();
    request.open("GET", relatedProductsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        var source = container.querySelector('.related-products[data-intent="' + intent + '"]') || container.querySelector('.related-products');
        relatedProductsSection.innerHTML = source ? source.innerHTML : '';
        if (window.theme && theme.initAnimateOnScroll) { theme.initAnimateOnScroll(); }
      }
    };
    request.send();
  });
};
// Fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadRelatedProductsIntoSection();
  }
});
// Fetch the products on page load
loadRelatedProductsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
